import React from 'react';
import './Screenshots.css';

// Import local screenshots
import Screen1 from './Assets/screen1.png';
import Screen2 from './Assets/screen2.png';
import Screen3 from './Assets/screen3.png';
import Screen4 from './Assets/screen4.png';

const Screenshots = () => {
  return (
    <section className="screenshots" id="screenshots">
      <h2 className="screenshots_title">App Screenshots</h2>

      <div className="screenshots_list">
        <div className="screenshots_item">
          <img src={Screen1} alt="QuickFix Screenshot 1" />
        </div>

        <div className="screenshots_item">
          <img src={Screen2} alt="QuickFix Screenshot 2" />
        </div>

        <div className="screenshots_item">
          <img src={Screen3} alt="QuickFix Screenshot 3" />
        </div>

        <div className="screenshots_item">
          <img src={Screen4} alt="QuickFix Screenshot 4" />
        </div>
      </div>
    </section>
  );
};

export default Screenshots;